import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import styles from "../Pages/Views/Employee/CheckInOut/checkInPage.module.less";
import {
    Body_16_Coral_Primary_Regular_16,
    Title_20_Coral_Strong_emphasis_20
} from "@UI/typography/generated/typography.tsx";
import {Gt} from "@src/i18n/Gt.tsx";
import {GPSWait} from "@UI/illustrationsSvg/GPSWait.tsx";
import cn from "classnames";


export const GPSWaitModal = () => {
    return (
        <Stack grow alignItems={"center"} justifyContent={"center"} direction={"column"} gap={16}
               className={styles.checkPopup}>
            <GPSWait/>
            <Stack direction={"column"} alignItems={"center"} style={{width: "272px"}}>
                <Stack className={styles.title} justifyContent={"center"}>
                    <Title_20_Coral_Strong_emphasis_20>
                        <Gt>The timestamp has been recorded!</Gt>
                    </Title_20_Coral_Strong_emphasis_20>
                </Stack>
                <Stack className={cn(styles.title, styles.subtext)} justifyContent={"center"}>
                    <Body_16_Coral_Primary_Regular_16>
                        <Gt>Currently retrieving location information...</Gt>
                    </Body_16_Coral_Primary_Regular_16>
                </Stack>
            </Stack>
        </Stack>
    )
}